import React, { useEffect } from 'react';

// Règle de la plateforme : tout ce qui est simulé est signalé en permanence.
// Mon Orient est une boutique de démonstration : produits et paiement fictifs (paiement Stripe simulé).
const HAUTEUR = 34;

const DemoBanner = () => {
  useEffect(() => {
    const precedent = document.body.style.paddingBottom;
    document.body.style.paddingBottom = `${HAUTEUR}px`;
    if (!document.title.startsWith('Démonstration')) document.title = `Démonstration · ${document.title}`;
    return () => { document.body.style.paddingBottom = precedent; };
  }, []);

  return (
    <div
      role="status"
      aria-label="Boutique de démonstration"
      style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 10000, minHeight: HAUTEUR,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '6px 12px',
        background: '#b45309', color: '#fff', fontSize: 13, fontWeight: 700, textAlign: 'center',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.25)',
      }}
    >
      BOUTIQUE DE DÉMONSTRATION — produits et paiement fictifs : aucune commande n'est livrée, aucun paiement réel n'est prélevé.
    </div>
  );
};

export default DemoBanner;
